import React from 'react';
import '../styles/theme.css';
import '../styles/Leads.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import LeadsStepRail from '../components/LeadsStepRail';
import LeadsLeadRowsPanel from '../components/LeadsLeadRowsPanel';
import LeadsSavedListSelector from '../components/LeadsSavedListSelector';
/* IMPORTS */

function LeadsPage() {
  const [selectedRunId, setSelectedRunId] = React.useState(null);
  return (
    <div className="le-root">
      <div className="le-layout-1">
        <div id="leadsnavbar" className="le-slot-leadsnavbar">
          <Navbar activePage={"Leads"} />
        </div>
        <div className="le-layout-2">
          <div id="leadssteprail" className="le-slot-leadssteprail">
            <LeadsStepRail />
          </div>
          <div className="le-layout-3">
            <div id="leadssavedlistselector" className="le-slot-leadssavedlistselector">
              <LeadsSavedListSelector selectedRunId={selectedRunId} onSelectRun={setSelectedRunId} />
            </div>
            <div id="leadsleadrowspanel" className="le-slot-leadsleadrowspanel">
              <LeadsLeadRowsPanel selectedRunId={selectedRunId} />
            </div>
          </div>
        </div>
        <div id="leadsfooter" className="le-slot-leadsfooter">
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default LeadsPage;